

















































































































































































import Vue from "vue";
import Collapse from "@/components/ui/Collapse.vue";
import Fieldset from "@/components/ui/Fieldset.vue";
import SmallTable, { Header, Action } from "@/components/ui/SmallTable.vue";
import DeleteDialog from "@/components/dialog/DeleteDialog.vue";
import UploadDialog from "@/components/dialog/UplaodDialog.vue";
import SaveDialog from "@/components/dialog/SaveDialog.vue";
import LoadingScreen from "@/components/dialog/LoadingScreen.vue";

import {
  Element,
  Sachstand,
  Dokument,
  UploadDokument,
  Kategorie,
  Rolle,
  Foerderung,
} from "@/types";
import { Kommune, Konzept } from "@/types/Kommune";
import { erklServiceInstance } from "@/services/ErklService";
import AlertService from "@/services/libs/AlertService";
import { konzeptServiceInstance } from "@/services/KonzeptService";
import { alertError } from "@/services/ErrorAlert";
import { RequestError } from "@/services/AuthService";
import ValidationService from "@/services/ValidationService";
import MultiselectWithFilter from "@/components/ui/MultiselectWithFilter.vue";
import ContactTable from "@/components/ui/ContactTable.vue";
import { Ansprechpartner } from "@/types/Ansprechpartner";

export default Vue.extend({
  name: "PreventionConceptsTab",
  components: {
    MultiselectWithFilter,
    Collapse,
    Fieldset,
    SmallTable,
    DeleteDialog,
    UploadDialog,
    SaveDialog,
    LoadingScreen,
    ContactTable,
  },
  props: {
    /** kommune id */
    id: {
      type: [String, Number],
      required: true,
    },
    /** edit mode */
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data: function () {
    return {
      isLoading: false,
      updatekonepte: 0,
      isFoerderungLoading: false,
      isUploading: false,
      isDownloading: false,
      uploadProgress: undefined as undefined | number,
      downloadProgress: undefined as undefined | number,
      openConceptIndex: 0,
      openDeleteDialog: false,
      openUploadDialog: false,
      openSaveDialog: false,
      konzepte: [] as Konzept[],
      institutionen: [] as Element[],
      sachstaende: [] as Sachstand[],
      categories: [] as Kategorie[],
      foerderungen: [] as Foerderung[],
      rollen: [] as Rolle[],
      newDokument: {} as UploadDokument,
      documentActions: [
        {
          title: "Dokument Öffnen",
          type: "is-primary",
          icon: "download",
          public: true,
          f: (d: any): void => (this as any).openDokument(d),
        },
      ] as Action[],
    };
  },
  computed: {
    konzeptKommunen(): any {
      return this.konzepte &&
        this.konzepte.length &&
        this.openConceptIndex != -1
        ? this.konzepte[this.openConceptIndex].kommunen
        : [];
    },
    newAnsprechpartner(): Ansprechpartner {
      return {
        institutionen: [] as Element[],
      } as Ansprechpartner;
    },
  },
  mounted() {
    this.isLoading = true;

    Promise.all([
      erklServiceInstance
        .getSachstaende()
        .then((data: Sachstand[]) => (this.sachstaende = data)),

      erklServiceInstance
        .getKategorien()
        .then((data: Kategorie[]) => (this.categories = data)),

      erklServiceInstance
        .getRollen()
        .then((data: Rolle[]) => (this.rollen = data)),

      konzeptServiceInstance.getKonzepte(this.id).then((data: Konzept[]) => {
        this.konzepte = data.sort((a, b) => (a.id > b.id ? 1 : -1));
      }),
    ])
      .then(() => this.$emit("loaded", this.konzepte))
      .catch((error: any) => alertError(error))
      .finally(() => {
        this.isLoading = false;
      });
  },
  methods: {
    resetAnsprechpartner: function (data: Ansprechpartner) {
      const items = this.konzepte[this.openConceptIndex].ansprechpartner.map(
        (x) =>
          x.id === data.id
            ? {
                ...x,
                rollen: [],
                namen: [],
                telefon: "",
                email: "",
                bemerkung: "",
              }
            : x,
      );
      this.konzepte[this.openConceptIndex].ansprechpartner = items;
    },

    removeAnsprechpartner: function (data: Ansprechpartner) {
      const items = this.konzepte[this.openConceptIndex].ansprechpartner.map(
        (x) =>
          x.id === data.id
            ? { ...x, rollen: [], telefon: "", email: "", bemerkung: "" }
            : x,
      );
      this.konzepte[this.openConceptIndex].ansprechpartner = items;
    },

    getAnsprechpartner: function (data: Ansprechpartner) {
      console.info("reset aaa " + data.checkId);
      const items = this.konzepte[this.openConceptIndex].ansprechpartner.map(
        (x) => (x.id === data.id ? data : x),
      );
      this.konzepte[this.openConceptIndex].ansprechpartner = items;
    },

    tableDocumentsHeader(konzept: Konzept): Header[] {
      return [
        {
          field: "kommune",
          label: "Kommune",
          display: (item: any): String => item?.bez || "-",
          type: "select",
          placeholder: "auswählen",
          options: konzept.kommunen,
          sortable: true,
        },
        { field: "bezeichnung", label: "Bezeichnung", sortable: true },
        {
          field: "kategorie",
          label: "Kategorie",
          display: (item: any): String => item?.bez || "-",
          type: "select",
          placeholder: "auswählen",
          options: this.categories,
          sortable: true,
        },
        {
          field: "kurzbeschreibung",
          label: "Kurzbeschreibung",
          type: "textarea",
          maxlength: 2000,
          sortable: true,
        },
        {
          field: "filesize",
          type: "filesize",
          label: "Größe",
          readonly: true,
          sortable: true,
          numeric: true,
        },
        { field: "autor", label: "Autor", readonly: true, sortable: true },
        {
          field: "datum",
          label: "Datum",
          type: "date",
          readonly: true,
          sortable: true,
        },
      ] as Header[];
    },

    getLetter(i: number): string {
      return (i + 10).toString(36).toUpperCase();
    },
    /** is triggered by autocomplete input change */
    searchFoerderungen(value: string) {
      if (value && value.length >= 3) {
        this.isFoerderungLoading = true;
        erklServiceInstance
          .getFoerderungen(value)
          .then((data: Foerderung[]) => (this.foerderungen = data))
          .finally(() => (this.isFoerderungLoading = false));
      }
    },
    /** is triggered if the new concept button is clicked */
    onNewKonzept() {
      const newKonzeptExist = this.konzepte.some((el) => el.id == undefined);
      // if already a new konzept exist
      if (newKonzeptExist) {
        AlertService.warning(
          "Es kann immer nur ein Vorsorgekonzept neu angelegt werden. <br/> Bitte zuerst speichern!",
        );
      } else {
        // add an empty new concept with arrays initlised
        this.konzepte.push({
          dokumente: [] as Dokument[],
          ansprechpartner: [] as Ansprechpartner[],
          kommuneId: this.id,
        } as Konzept);
        // open the new concept
        this.openConceptIndex = this.konzepte.length - 1;
      }
    },
    /** is triggered if the delete dialog is confirmed */
    onDeleteConfirm() {
      const concept = this.konzepte[this.openConceptIndex];
      if (concept?.id != undefined) {
        // delete existing concept
        this.isLoading = true;
        konzeptServiceInstance
          .deleteKonzept(concept.id)
          .then(() => {
            // remove concept
            this.konzepte.splice(this.openConceptIndex, 1);
            // close all concepts
            this.openConceptIndex = -1;
            AlertService.info("Vorsorgekonzept gelöscht!");
          })
          .catch((error: RequestError) =>
            AlertService.error(
              "Beim Löschen des Vorsorgekonzepts ist ein Fehler aufgetreten!",
              "Bitte versuchen Sie es in einiger Zeit erneut!",
              "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
              "Fehlermeldung: " + error.message,
            ),
          )
          .finally(() => (this.isLoading = false));
      } else {
        // delete new concept
        // remove concept
        this.konzepte.splice(this.openConceptIndex, 1);
        // close all concepts
        this.openConceptIndex = -1;
      }
    },
    onUpload(document: UploadDokument) {
      if (this.konzepte[this.openConceptIndex]?.id == undefined) {
        AlertService.info(
          "Bitte zuerst das neu angelegte Vorsorgekonzept speichern!",
        );
        return;
      }
      this.openUploadDialog = true;
      this.newDokument = document;
      // create documents array if not exist
      if (!this.konzepte[this.openConceptIndex].dokumente)
        this.konzepte[this.openConceptIndex].dokumente = [];
    },
    onUploadConfirm(document: UploadDokument) {
      if (!document.file) {
        AlertService.warning(
          "Upload ungültig!",
          "Es muss eine Datei ausgewählt werden.",
        );
        return;
      }
      // delete existing concept
      this.isUploading = true;
      konzeptServiceInstance
        .uploadDokument(
          this.konzepte[this.openConceptIndex].id,
          document,
          (e: any) => (this.uploadProgress = (e.loaded / e.total) * 100),
        )
        .then((document: Dokument) => {
          // add new document to list
          this.konzepte[this.openConceptIndex].dokumente.unshift(document);
          // clear newDokument object
          this.newDokument = {} as UploadDokument;
          AlertService.info("Dokument hochgeladen!");
        })
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Hochladen des Dokuments ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => {
          this.isUploading = false;
          this.uploadProgress = undefined;
        });
    },
    onUploadCancel() {
      // remove new document from list
      const index = this.konzepte[this.openConceptIndex].dokumente.findIndex(
        (el: any) => el.id == (this.newDokument as any)?.id,
      );
      if (index != -1)
        this.konzepte[this.openConceptIndex].dokumente.splice(index, 1);

      // clear newDokument object
      this.newDokument = {} as UploadDokument;
    },
    onSaveConfirm() {
      const concept = this.konzepte[this.openConceptIndex];
      this.isLoading = true;
      (concept?.id != undefined
        ? // update existing concept
          konzeptServiceInstance
            .updateKonzept(concept.id, concept)
            .then((data: Konzept) => {
              if (data) this.konzepte[this.openConceptIndex] = data;
              this.updatekonepte++;
              AlertService.info("Vorsorgekonzept gespeichert!");
            })
        : // create new concept
          konzeptServiceInstance
            .createKonzept(concept)
            .then((data: Konzept) => {
              if (data) this.konzepte[this.openConceptIndex] = data;
              this.updatekonepte++;
              AlertService.info("Vorsorgekonzept gespeichert!");
            })
      )
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Speichern des Vorsorgekonzepts ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => (this.isLoading = false));
    },
    openDokument(dokument: Dokument) {
      const concept = this.konzepte[this.openConceptIndex];
      this.isDownloading = true;
      konzeptServiceInstance
        .openDokument(
          concept.id,
          dokument,
          (e: any) => (this.downloadProgress = (e.loaded / e.total) * 100),
        )
        .catch((error: RequestError) =>
          AlertService.error(
            "Beim Öffnen des Dokuments ist ein Fehler aufgetreten!",
            "Bitte versuchen Sie es in einiger Zeit erneut!",
            "Wenn das Problem weiterhin besteht, informieren Sie bitte den Helpdesk!",
            "Fehlermeldung: " + error.message,
          ),
        )
        .finally(() => {
          this.isDownloading = false;
          this.downloadProgress = undefined;
        });
    },
    validateAndSave() {
      let valid = true;
      for (
        let i = 0;
        i < this.konzepte[this.openConceptIndex].ansprechpartner.length;
        i++
      ) {
        if (
          !ValidationService.validEmail(
            this.konzepte[this.openConceptIndex].ansprechpartner[i].email,
          )
        ) {
          valid = false;
          break;
        }
      }
      if (valid) this.openSaveDialog = true;
      else AlertService.error("Die Emailaddresse(n) sind nicht valide!");
    },
  },
});
